/**
 * Created by bholmes on 4/19/2016.
 */
import Actions from '../constants/Actions';
import LoginStore from '../stores/LoginStore';

function loginService() {
  return new Promise((resolve, reject) => {
    function serviceCheck() {
      if (window.ignite.employeeLoginService) {
        resolve(window.ignite.employeeLoginService);
      } else {
        console.log('employeeLoginService not available.  Trying again.');
        window.setTimeout(serviceCheck, 100);
      }
    }

    window.setTimeout(serviceCheck, 0);
  });
}

/**
 * Loads an employee by either an ignite employee id or a 3rd party (client's) identifier.
 *
 * First tries to look by ignite id, then, if not found, search by client's id.
 * If an employee is found, it will be selected.
 *
 * @param context
 * @param selectedEmployeeId
 * @param thirdPartyId
 * @returns {Promise.<*>}
 */
export async function loadEmployeeById(context, {selectedEmployeeId, thirdPartyId}) {
  if (selectedEmployeeId || thirdPartyId) {
    console.log('Logging in with selected employee', {selectedEmployeeId, thirdPartyId});
    const employeeLoginService = await loginService();

    const employee = await employeeLoginService.get(selectedEmployeeId || thirdPartyId);

    if (employee) {
      context.dispatch(Actions.EMPLOYEES_LOADED, [employee]);
      await context.executeAction(selectEmployee, employee);
      return employee;
    } else {
      console.log("Looking for employee, but found none");
    }
  } else {
    console.log('No employee selected, falling back to normal login dialog.');
  }
}

export async function loadEmployees(context, {searchValue = ''}) {
  context.dispatch(Actions.EMPLOYEE_SEARCH_STARTED);
  context.dispatch(Actions.EMPLOYEE_SEARCH_VALUE_CHANGED, searchValue);

  const employeeLoginService = await loginService();
  const result = await employeeLoginService.search(searchValue);
  context.dispatch(Actions.EMPLOYEES_LOADED, result);

  return result;
}

export async function searchEmployeeConflicts(context, {searchByEmail = false, searchById = false}) {
  context.dispatch(Actions.EMPLOYEE_SEARCH_STARTED);
  const LoginStore = context.getStore('LoginStore');
  const employeeLoginService = await loginService();
  const currentEmployee = LoginStore.getSelectedEmployee() || {};
  let result = {
    email: false,
    id: false
  };

  if(searchByEmail) {
    const byEmail = await employeeLoginService.searchByEmail(searchByEmail);
    if (byEmail && byEmail.id && byEmail.id !== currentEmployee.id) {
      result.email = byEmail;
    }
  }
  if(searchById) {
    const byId = await employeeLoginService.searchByThirdPartyId(searchById);
    if (byId && byId.id && byId.id !== currentEmployee.id) {
      result.id = byId;
    }
  }
  context.dispatch(Actions.EMPLOYEES_CONFLICTS_LOADED, result);

  return result;
}

export async function loadBranches(context, { searchValue = '' }) {
  context.dispatch(Actions.BRANCH_SEARCH_STARTED);

  if (searchValue.length >= 3) {
    console.log('searching for branches', searchValue);
    const employeeLoginService = await loginService();
    const result = await employeeLoginService.findBranches(searchValue);

    context.dispatch(Actions.BRANCHES_LOADED, result);
    return result;
  } else {
    context.dispatch(Actions.BRANCHES_LOADED, []);
    return [];
  }
}

export async function newEmployee(context) {
  context.dispatch(Actions.NEW_EMPLOYEE_SELECTED);
}

export async function editEmployee(context, employee) {
  context.dispatch(Actions.EDIT_EMPLOYEE_SELECTED, employee);
}

export async function employeeValidationError(context, errors) {
  context.dispatch(Actions.EMPLOYEE_UPDATE_ERROR, errors.map(error => {
    return {
      key: error.path,
      errors: [error.message]
    };
  }));
}

export async function saveEmployeeProfile(context, {employee}) {
  context.dispatch(Actions.EMPLOYEE_UPDATE_STARTED);

  try {
    const employeeLoginService = await loginService();
    const result = await employeeLoginService.save(employee);

    if (result.status === 'success') {
      context.dispatch(Actions.EMPLOYEE_UPDATE_SUCCESSFUL, result.employee);
    } else {
      if (result.errors) {
        context.dispatch(Actions.EMPLOYEE_UPDATE_ERROR, result.errors);
      }
      context.dispatch(Actions.EMPLOYEE_UPDATE_FAILED, result);
    }

  } catch (ex) {
    context.dispatch(Actions.EMPLOYEE_UPDATE_FAILED);
  }
}

export async function selectEmployee(context, employee) {
  console.log('Employee clicked', employee);

  if (!employee.branches || employee.branches.length === 0) {
    await context.executeAction(editEmployee, employee);
  } else {
    context.dispatch(Actions.EMPLOYEE_SELECTED, employee);
  }
}

export async function employeeCancelClicked(context) {
  context.dispatch(Actions.EMPLOYEE_UPDATE_CANCELED);
}

export async function backToSearchClicked(context) {
  context.dispatch(Actions.EMPLOYEE_DESELECTED);
  const LoginStore = context.getStore('LoginStore');
  context.executeAction(loadEmployees, {
    searchValue: LoginStore.getEmployeeSearchValue()
  });
}

export async function login(context, {
  employee,
  branch
}) {
  context.dispatch(Actions.EMPLOYEE_LOGIN_STARTED);
  const employeeLoginService = await loginService();
  const result = await employeeLoginService.login({
    employee,
    branch
  });

  if (result.status === 'success') {
    const {employee: loggedInEmployee, branch: loggedInBranch} = result;
    context.dispatch(Actions.EMPLOYEE_LOGGED_IN);
    console.log('Employee logged in', {
      employee: loggedInEmployee,
      branch: loggedInBranch
    });

    if (window.ignite.employeeLoggedIn) {
      window.ignite.employeeLoggedIn({
        employee: loggedInEmployee,
        branch: loggedInBranch
      });
    }
  }
}



/** WEBPACK FOOTER **
 ** ./src/main/js/employeeLogin/actions/SearchActionCreators.js
 **/